import { render, staticRenderFns } from "./HeatmapVis.vue?vue&type=template&id=63909088&scoped=true&"
import script from "./HeatmapVis.vue?vue&type=script&lang=js&"
export * from "./HeatmapVis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63909088",
  null
  
)

export default component.exports